import axios from 'axios';

axios.interceptors.response.use(
    (response) => {
      return response;
    },
    function(error) {
      console.log(error);
      if (error.response.status === 401 ) {
        localStorage.setItem('state', '');
        window.location.reload();
      }

      return Promise.reject(error);
    },
);

export default axios;
